import { IMultiOccurrenceOptions, IMultiOccurrence } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IStateParamsService } from 'angular-ui-router';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IComponentController } from 'angular';

interface IPageAC0032 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    dahMultiOccurrenceOptions: IMultiOccurrenceOptions;
    valeursEcran: any;
}
/* @ngInject */
export default function Ac0032Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    MenuItemForage: IMenuItemForageClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    Pagination: IPaginationClass,
    $stateParams: IStateParamsService,
    ac0010Route: IRoute,
    in0043Route: IRoute,
    cp2010Route: IRoute,
    rc0007Route: IRoute,
    rc0001Route: IRoute) {
    const vm: IPageAC0032 = this;

    vm.$onInit = $onInit;
    function $onInit() {

        // @TODO ajouter les routes de forage quand les écrans seront faits
        const ac0037Route = { NAME: 'secure.accueil' };
        const ac0070Route = { NAME: 'secure.accueil' };
        const pd0006Route = { NAME: 'secure.accueil' };
        const rc0002Route = { NAME: 'secure.accueil' };
        const rc0006Route = { NAME: 'secure.accueil' };
      //  const rc0007Route = { NAME: 'secure.accueil' };

        vm.valeursEcran = ecranDetails.valeurs;
        vm.dahMultiOccurrecneOptions = { 
            bloc: 'dah',
            fonctions: {
                suiviModification: false
            },
            colonnesCachees: [
                'syscleintref',
                'vaedahtyp',
                't_clereq',
                'ecrcod',
                't_numdoc',
                'doccleintaff'
            ],
            colonnesVisibles: [
                { nom: 't_datcre', largeur: 160 },
                { nom: 't_type', largeur: 141 },
                {
                    nom: 't_numdoc', largeur: 150, menu: [
                     new MenuItemForage(
                        'LBL_DER',
                        (rowData: any) => getForage(rowData) || '',
                        (rowData: any) => ({
                            id: rowData.t_clereq,
                            daccleint: vm.multiOccurrence.etatSelected.criteresSuggeresData.daccleint
                        }),
                        {
                            icon: 'exit_to_app',
                            fonction: 'BTNFOR',
                            hidden: (rowData: any) => !getForage(rowData),
                        },
                    )]
                },
                { nom: 'dahqte', largeur: 100 },
                { nom: 'dahprxuni', largeur: 126 },
                { nom: 'dahcom', largeur: 340 }
            ],
            pagination: new Pagination({
                nombreElementPage: 10,
                nbElementsPossibles: [10, 20, 30]
            })
        };  
        vm.multiOccurrenceOptions = {
            criteresSuggeres: new Formulaire([
                new FormulaireItem('daccleint', {
                    required: true,
                    ignoreEtat: vm.valeursEcran.save_etat ,
                    default: () => (isForage()) ? $stateParams.daccleint : undefined,
                    readonly: isForage()
                }),
                new FormulaireItem('refcleint', {
                    required: false,
                    ignoreEtat: vm.valeursEcran.save_etat ,
                    default: () => (isForage()) ? vm.valeursEcran.refcleint__refcod : undefined,
                    readonly: isForage()
                }),
                new FormulaireItem('sysboncmd', {
                    required: false,
                    ignoreEtat: vm.valeursEcran.save_etat ,
                    readonly: isForage()
                }),
                new FormulaireItem('t_typdoc', {
                    hidden: true,
                    ignoreEtat: vm.valeursEcran.save_etat ,
                    default: () => (isForage()) ? vm.valeursEcran.t_type : undefined
                }),
                new FormulaireItem('t_type', {
                    required: false,
                    ignoreEtat: vm.valeursEcran.save_etat ,
                    default: () => (isForage()) ? vm.valeursEcran.t_type : undefined,
                    readonly: true,
                }),
                new FormulaireItem('t_techn', {
                    ignoreEtat: vm.valeursEcran.save_etat ,
                    default: () => (isForage()) ? vm.valeursEcran.t_techn : undefined,
                    readonly: true
                }),
                new FormulaireItem('dacdsc', {
                    readonly: true,
                    ignoreEtat: vm.valeursEcran.save_etat ,
                    default: () => (isForage()) ? vm.valeursEcran.dacdsc : undefined
                }),
                new FormulaireItemSautDeLigne(),
                new FormulaireItem('flgindfer', {
                   // default: 1,
                    required: true,
                    ignoreEtat: vm.valeursEcran.save_etat ,
                    readonly: isForage()
                })
            ]),
            fonctions: {
                rechercheCollapsable: false,
                criteresSuggeresVisibles:( !isForage() && vm.valeursEcran.save_etat ),
            },
            pagination: new Pagination({
                nombreElementPage: 10,
                nbElementsPossibles: [10, 20, 30]
            }),
            colonnesFixesGauche: [
                { nom: 'dailigcar', largeur: 90 }
            ],
            colonnesVisibles: [
                { nom: 'dainumcat', largeur: 136 },
                { nom: 'procod', largeur: 110, hidden: () => vm.multiOccurrence.etatSelected.criteresSuggeresData.t_typdoc !== 2 },
                { nom: 'daidsc', largeur: 200 },
                { nom: 'daiseqave', largeur: 90 },
                { nom: 'taxcod', largeur: 70 },
                { nom: 'daiprxuni', largeur: 126 }
            ],
            colonnesFixesDroite: [
                { nom: 'dahqtecmd', largeur: 126 },
                { nom: 'dahqterec', largeur: 126 },
                { nom: 'dahqtefac', largeur: 126 },
                { nom: 'dahqteret', largeur: 126 }
            ],colonnesCachees:['save_etat'],
            multiOccurrenceOptionsEnfant: vm.dahMultiOccurrecneOptions
        };


        // Fonction d'identification de l'écran pour le forage
        function getForage(data: any): string | null {
            if (!data.t_numdoc) {
                return null;
            }
            if (data.vaedahtyp === 'REQ') {
                return cp2010Route.NAME;
            } else if (data.ecrcod === 'AC0010-02') {
                return ac0010Route.NAME;
            } else if (data.ecrcod === 'AC0010-00') {
                return ac0010Route.NAME;
            } else if (data.ecrcod === 'AC0037-00') {
                return ac0037Route.NAME;
            } else if (data.ecrcod === 'AC0070-00') {
                return ac0070Route.NAME;
            } else if (data.ecrcod === 'AC0070-01') {
                return ac0070Route.NAME;
            } else if (data.ecrcod === 'IN0043-00') {
                return in0043Route.NAME;
            } else if (data.ecrcod === 'PD0006-00') {
                return pd0006Route.NAME;
            } else if (data.ecrcod === 'RC0001-00') {
                return rc0001Route.NAME;
            } else if (data.ecrcod === 'RC0002-00') {
                return rc0002Route.NAME;
            } else if (data.ecrcod === 'RC0006-00') {
                return rc0006Route.NAME;
            } else if (data.ecrcod === 'RC0007-00') {
                return rc0007Route.NAME;
            }

            return null;
        }
        function isForage(): boolean {
            return $stateParams?.isforage && $stateParams?.isforage === "1"
        }
    }
}
